import { createFileRoute, redirect } from "@tanstack/react-router";

/** /dashboard/admin → always redirect to /dashboard/admin/users. */
export const Route = createFileRoute("/dashboard/admin/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/admin/users" });
  },
});
